<template>
  <div class="home-page">
    <framework> </framework>
    <div style="display: flex;justify-content: center;align-items: center;">
      <ins class="adsbygoogle"
      style="display:inline-block;width:728px;height:90px"
      data-ad-client="ca-pub-3429364286188447"
      data-ad-slot="6770680689"></ins>
    </div>
    <div class="title-font">
      <div class="title-font-one">Transform and Edit Faces with<span class="title-font-two">&nbsp;Face Swapping</span></div>
    </div>
    <div class="home-top">
      <div class="home-top-menu">
        <div class="home-top-menu-photo" :class="2 === isPhoto ? 'active' : ''" @click="MenuClick(2)">Video Face Swap</div>
        <div class="home-top-menu-photo" :class="1 === isPhoto ? 'active' : ''" @click="MenuClick(1)">Photo Face Swap</div>
      </div>
    </div>
    <div v-if="1 === isPhoto" class="home-top-content">
      <div class="home-top-content-photo">
        <div class="home-top-content-img">
          <div>
            <el-upload
              v-if="isLogin"
              :action="upload.url"
              :headers="upload.headers"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload">
              <div>
                  <img class="home-top-content-img-upload" src="@/assets/img/upload-home.png" @click="uphead"></img>
              </div>
            </el-upload>
            <div v-else class="home-top-content-photo-headimg-box-l">
                <img class="home-top-content-img-upload" src="@/assets/img/upload-home.png" @click="loginClick"></img>
            </div>
          </div>
          <!-- <img class="home-top-content-img-upload" src="@/assets/img/upload-home.png" alt="">  -->
          <div v-infinite-scroll="load" style="overflow:auto; height:500px">
            <div v-for="(item, index) in topTemplatePhotoList" @click="ChangePhotoTeplate(item)" :key="index" class="home-top-content-img-upload-content">
              <el-image
              class="home-top-content-img-upload-icon"
              :src="item.startImg"
              fit="cover">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
            
            <!-- <div class="home-top-content-img-upload-content">
              <img class="home-top-content-img-upload-icon" src="@/assets/img/home-body-content.png" alt="">
            </div> -->
          </div>
        </div>
        <div class="home-top-content-photo-main" v-loading="loading"
          element-loading-text="loading"
          element-loading-background="#000000"
          >
          <el-image 
            style="width: 360px; height: 640px"
            :src="UploadImg.coverUrl"
            fit="cover"
            :preview-src-list="topPhotosrcList">
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </div>
        <div class="home-top-content-photo-face">
          <div style="width: 100%;">
            <div v-if="!isDown"class="home-top-content-photo-face-text">
              Add your face photo to swap
            </div>
            <div v-else class="home-top-content-photo-face-text">Face swap complete</div>
            <div class="home-top-content-photo-swapping"  v-for="(item, index) in photoHeadList" :key="index">
              <div>
                <el-image
                  class="home-top-content-photo-swapping-head"
                  :src="item.headImg"
                  fit="cover"
                  lazy
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
                <!-- <img class="home-top-content-photo-swapping-head" :src="item.headImg" alt=""> -->
              </div>
              <div>
                <img class="home-top-content-photo-swapping-change" src="@/assets/img/change.png" alt="">
              </div>
              <div style="position: relative;">
                <div class="home-top-content-photo-headimg-box-l-img-box">
                  <div v-loading="headLoading">
                    <el-upload
                      v-if="isLogin"
                      :action="upload.headUrl"
                      :headers="upload.headers"
                      :show-file-list="false"
                      :on-success="(response, file, fileList) => {
                        return handleAvatarSuccessByPhotoHead(response, file, fileList, index);
                      }"
                      :before-upload="beforeAvatarUploadHead">
                      <div class="home-top-content-photo-headimg-box-l">
                        <div v-if="item.choseId == 0">
                          <div class="home-top-content-photo-headimg-box-l-upload">
                            <img class="home-top-content-photo-headimg-box-l-img-box-shizicha" src="@/assets/img/shizicha.png"></img>
                          </div>
                          <div>
                            <img class="home-top-content-photo-headimg-box-l-img-box-text" src="@/assets/img/addtext.png"></img>
                          </div>
                        </div>
                        <div v-else>
                          <el-image
                            class="home-top-content-photo-headimg-box-l-img"
                            :src="item.choseImgUrl"
                            fit="cover"
                            lazy
                          >
                            <div slot="error" class="image-slot">
                              <i class="el-icon-picture-outline"></i>
                            </div>
                          </el-image>
                          <!-- <img class="home-top-content-photo-headimg-box-l-img" :src="item.choseImgUrl"></img> -->
                        </div>
                      </div>
                    </el-upload>
                    <div v-else class="home-top-content-photo-headimg-box-l">
                      <img class="home-top-content-photo-headimg-box-l-img" src="@/assets/img/addyourface.png" @click="loginClick"></img>
                    </div>
                </div>
              </div>
              <img v-if="item.choseId != 0" class="home-top-content-photo-headimg-box-l-img-edit-icon" src="@/assets/img/editicon.png"></img>
              </div>
            </div>
            <div class="home-top-content-photo-start">
              <img v-if="!isClick && isShowSwap" @click="startSwap"style="width: 250px; height:35px;cursor: pointer;" src="@/assets/img/home-start.png" alt="">
              <img v-if="isClick" style="width: 250px; height:35px;" src="@/assets/img/faceSwapping.png" alt="">
            </div>
            <div class="home-top-content-photo-down">
              <img v-if="isDown" @click="DownImg"style="width: 250px; height:35px;cursor: pointer;" src="@/assets/img/down.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="2 === isPhoto" class="home-top-content">
      <div class="home-top-content-photo">
        <div class="home-top-content-img">
          <div>
            <el-upload
              v-if="isLogin"
              :action="uploadVideoConfig.url"
              :headers="uploadVideoConfig.headers"
              :show-file-list="false"
              :on-success="handleVideoSuccess"
              :before-upload="beforeVideoUpload">
              <div>
                  <img class="home-top-content-img-upload" src="@/assets/img/upload-home.png" @click="uphead"></img>
              </div>
            </el-upload>
            <div v-else class="home-top-content-photo-headimg-box-l">
                <img class="home-top-content-img-upload" src="@/assets/img/upload-home.png" @click="loginClick"></img>
            </div>
          </div> 
          <div v-infinite-scroll="load" style="overflow:auto; height:500px">
            <div v-for="(item, index) in topTemplatevideoList" @click="ChangeVideoTeplate(item)" :key="index" class="home-top-content-img-upload-content">
              <el-image
              class="home-top-content-img-upload-icon"
              :src="item.startImg"
              fit="cover">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
          </div>
        </div>
        <div class="home-top-content-photo-main" v-loading="videoloading"
          element-loading-text="loading"
          element-loading-background="#000000">
          <div @click="OpenVideoUrlPlay" style="position: relative">
            <el-image
              class="templateview-content-video-content-img"
              :src="UploadVideo.coverUrl"
              fit="scale-down"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
            <div style="position: absolute;
              margin-top: -26px;
              margin-left: -26px;
              top: 50%;
              left: 50%;">
              <img style="width: 52px; height: 52px" src="@/assets/img/playerBtn.png" />
            </div>
          </div>
        </div>
        <div class="home-top-content-photo-face">
          <div style="width: 100%;">
            <div v-if="!isVideoDown" class="home-top-content-photo-face-text">
              Add your face photo to swap
            </div>
            <div v-else class="home-top-content-photo-face-text">Face swap complete</div>
            <div class="home-top-content-photo-swapping"  v-for="(item, index) in videoHeadList" :key="index">
              <div>
                <el-image
                  class="home-top-content-photo-swapping-head"
                  :src="item.headImg"
                  fit="cover"
                  lazy
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
              <div>
                <img class="home-top-content-photo-swapping-change" src="@/assets/img/change.png" alt="">
              </div>
              <div style="position: relative;">
                <div class="home-top-content-photo-headimg-box-l-img-box">
                  <div v-loading="headLoading">
                    <el-upload
                      v-if="isLogin"
                      :action="upload.headUrl"
                      :headers="upload.headers"
                      :show-file-list="false"
                      :on-success="(response, file, fileList) => {
                        return handleAvatarSuccessByVideoHead(response, file, fileList, index);
                      }"
                      :before-upload="beforeVideoHeadUpload">
                      <div class="home-top-content-photo-headimg-box-l">
                        <div v-if="item.choseId == 0">
                          <div class="home-top-content-photo-headimg-box-l-upload">
                            <img class="home-top-content-photo-headimg-box-l-img-box-shizicha" src="@/assets/img/shizicha.png"></img>
                          </div>
                          <div>
                            <img class="home-top-content-photo-headimg-box-l-img-box-text" src="@/assets/img/addtext.png"></img>
                          </div>
                        </div>
                        <div v-else>
                          <el-image
                            class="home-top-content-photo-headimg-box-l-img"
                            :src="item.choseImgUrl"
                            fit="cover"
                            lazy
                          >
                            <div slot="error" class="image-slot">
                              <i class="el-icon-picture-outline"></i>
                            </div>
                          </el-image>
                          <!-- <img class="home-top-content-photo-headimg-box-l-img" :src="item.choseImgUrl"></img> -->
                        </div>
                      </div>
                    </el-upload>
                    <div v-else class="home-top-content-photo-headimg-box-l">
                      <img class="home-top-content-photo-headimg-box-l-img" src="@/assets/img/addyourface.png" @click="loginClick"></img>
                    </div>
                </div>
              </div>
              <img v-if="item.choseId != 0" class="home-top-content-photo-headimg-box-l-img-edit-icon" src="@/assets/img/editicon.png"></img>
              </div>
            </div>
            <div class="home-top-content-photo-start">
              <img v-if="!isVideoClick && isShowVideoSwap" @click="startVideoSwap"style="width: 250px; height:35px;cursor: pointer;" src="@/assets/img/home-start.png" alt="">
              <img v-if="isVideoClick" style="width: 250px; height:35px;" src="@/assets/img/faceSwapping.png" alt="">
            </div>
            <div class="home-top-content-photo-down">
              <img v-if="isVideoDown" @click="DownVideo"style="width: 250px; height:35px;cursor: pointer;" src="@/assets/img/down.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="home-body">
      <div class="home-body-title">
        <div style="border-radius: 5px 0px 0px 5px;" class="home-body-title-text" @click="ChangeIsTemplatesTag(1)" :class="1 === isTemplates ? 'active' : ''">
          Experience Templates
        </div>
        <div style="border-radius: 0px 5px 5px 0px;" class="home-body-title-text" @click="ChangeIsTemplatesTag(2)" :class="2 === isTemplates ? 'active' : ''">
          My Uploads&Works
        </div>
      </div>
      <div v-if="!isMyWork">
        <div class="home-body-content-menu">
        <div
            class="home-body-content-menu-style"
            @click="ChangeTag(0)"
            :class="0 === industryTabIndex ? 'active' : ''"
          >
            New
            <div :class="0 === industryTabIndex ? 'underline' : ''"></div>
          </div>
          <div
            class="home-body-content-menu-style"
            @click="ChangeTag(-1)"
            :class="-1 === industryTabIndex ? 'active' : ''"
          >
            <!-- <img class="topRec-img" src="@/assets/img/topRec.png" />  -->
            Featured Videos
            <div :class="-1 === industryTabIndex ? 'underline' : ''"></div>
          </div>
          <div
            class="home-body-content-menu-style"
            @click="ChangeTag(-2)"
            :class="-2 === industryTabIndex ? 'active' : ''"
          > Featured Photos
          <div :class="-2 === industryTabIndex ? 'underline' : ''"></div>
          </div>
          <div
            class="home-body-content-menu-style"
            @click="ChangeTag(9)"
            :class="9 === industryTabIndex ? 'active' : ''"
          > 
          <img class="topRec-img" src="@/assets/img/vip.png" />&nbsp;18+
          <div :class="9 === industryTabIndex ? 'underline' : ''"></div>
          </div>
          <div
            class="home-body-content-menu-style"
            @click="ChangeTag(-3)"
            :class="-3 === industryTabIndex ? 'active' : ''"
          > 
          <img class="topRec-img" src="@/assets/img/vip.png" />&nbsp;Videos
          <div :class="-3 === industryTabIndex ? 'underline' : ''"></div>
          </div>
          <div
            class="home-body-content-menu-style"
            @click="ChangeTag(-4)"
            :class="-4 === industryTabIndex ? 'active' : ''"
          > 
          <img class="topRec-img" src="@/assets/img/vip.png" />&nbsp;Photos
          <div :class="-4 === industryTabIndex ? 'underline' : ''"></div>
          </div>
          <div
            v-for="item in typeList"
            :key="item.id"
            class="home-body-content-menu-style"
            @click="ChangeTag(item.value)"
            :class="item.value === industryTabIndex ? 'active' : ''"
          >
            {{ item.label }}
            <div :class="item.value === industryTabIndex ? 'underline' : ''"></div>
          </div>
        </div>
        <div class="home-body-content">
          <div
            @click="handleGoFace(item)"
            style="position: relative;height:fit-content;"
            class="home-body-content-item"
            v-for="item in videoList"
            :key="item.id"
          >
           <div class="wrapper">
            <el-image
              v-if="item.startImg"
              @load="imgLoadOk(item)"
              style="max-width: 172px; max-height: 270px; background-color:red;"
              :src="item.startImg"
              fit="scale-down"
              lazy
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
            <img v-else class="home-body-content-img" src="@/assets/img/defalut.png" />
            <div
                style="
                  position: absolute;
                  margin-top: -26px;
                  margin-left: -26px;
                  top: 50%;
                  left: 50%;
                "
              >
                <img v-if="item.mediaType != 1  && item.isPhotoOk"style="width: 52px; height: 52px" src="@/assets/img/playerBtn.png" />
            </div>
            <div
              style="
                position: absolute;
                right:10px;
                bottom: 10px;
              "
            >
              <img v-if="item.isVip && item.isPhotoOk" style="width: 20px; height: 20px" src="@/assets/img/trynow.png" />
            </div>
           </div>
          </div>
          <div
            class="home-body-content-item"
            style="height: 0; overflow: hidden; opacity: 0"
            v-for="i in 8"
            :key="i + '-#'"
          >
            <img class="home-body-content-img" />
          </div>
          <div v-if="(industryTabIndex == -3 || industryTabIndex == 9)  && !this.userInfo.isVip && videoList.length > 0" class="overlay">
            <div style="text-align: center;">
              <img src="@/assets/img/lock.png" alt="Lock Icon" class="lock-icon" />
              <div class="lock-text">Discover incredible videos shared by our community! Subscribe today to </div>
              <div class="lock-text">access and enjoy all the exciting content.</div>
              <img @click="showPaymentDialog()" src="@/assets/img/UnlockVideos.png" class="lock-icon-unlock" />
            </div>
          </div>
          <div v-if="industryTabIndex == -4 && !this.userInfo.isVip && videoList.length > 0" class="overlay">
            <div style="text-align: center;">
              <img src="@/assets/img/lock.png" alt="Lock Icon" class="lock-icon" />
              <div class="lock-text">These amazing photos shared by our community are exclusively available </div>
              <div class="lock-text">to our subscribers. Subscribe now to explore and enjoy unlimited access!</div>
              <img @click="showPaymentDialog()" src="@/assets/img/UnlockPhotos.png" class="lock-icon-unlock" />
            </div>
          </div>
        </div>
      </div>
      <div v-if="isMyWork">
        <div class="home-body-content-menu">
          <div
            class="home-body-content-menu-style"
            @click="ChangeMyTag(0)"
            :class="0 === myTabIndex ? 'active' : ''"
          > My Videos
          </div>
          <div
            class="home-body-content-menu-style"
            @click="ChangeMyTag(1)"
            :class="1 === myTabIndex ? 'active' : ''"
          > My Photos
          </div>
          <div
            class="home-body-content-menu-style"
            @click="ChangeMyTag(2)"
            :class="2 === myTabIndex ? 'active' : ''"
          > My Works
          </div>
        </div>
        <div class="home-body-content">
          <div v-if="myTabIndex == 0"
            style="position: relative"
            class="home-body-content-item"
          >
          <el-upload
              v-if="isLogin"
              :action="uploadVideoConfig.url"
              :headers="uploadVideoConfig.headers"
              :show-file-list="false"
              :on-success="handleMyVideoSuccess"
              :on-progress = "handleFileProgress"
              :before-upload="beforeMyVideoUpload">
              <div>
                  <img style="width: 172px; height: 270px; " src="@/assets/img/uploadVideo.png" @click="uphead"></img>
              </div>
          </el-upload>
          <img v-else style="width: 172px; height: 270px;" src="@/assets/img/uploadVideo.png" @click="loginClick"></img>
          </div>
          <div v-if="myTabIndex == 1"
            style="position: relative"
            class="home-body-content-item"
          >
          <el-upload
              v-if="isLogin"
              :action="upload.url"
              :headers="upload.headers"
              :show-file-list="false"
              :on-success="handleMyAvatarSuccess"
              :on-progress = "handleFileProgress"
              :before-upload="beforeMyAvatarUpload">
              <div>
                  <img style="width: 172px; height: 270px; " src="@/assets/img/uploadPhoto.png" @click="uphead"></img>
              </div>
          </el-upload>
          <img v-else style="width: 172px; height: 270px;" src="@/assets/img/uploadPhoto.png" @click="loginClick"></img>
          </div>
          <div v-if="myTabIndex != 2"
            style="position: relative;cursor: auto;"
            class="home-body-content-item"
            v-for="item in myVideoList"
            :key="item.id"
          >
            <el-image
              v-if="item.startImg"
              style="width: 172px; height: 270px; background-color: #000000"
              :src="item.startImg"
              fit="scale-down"
              lazy
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
            <img v-else class="home-body-content-img" src="@/assets/img/defalut.png" />
            <div
              style="
                position: absolute;
                margin-top: -26px;
                margin-left: -26px;
                top: 50%;
                left: 50%;
              "
            >
              <img v-if="item.mediaType != 1"style="width: 52px; height: 52px" src="@/assets/img/playerBtn.png" />
            </div>
            <div class="home-body-content-img-share-overlay-buttons">
              <img @click="handleGoFace(item)" src="@/assets/img/swapFace.png" class="home-body-content-img-button">
              <img v-if="item.isShare" @click="handleChangeShare(item)" src="@/assets/img/Unshare.png" class="home-body-content-img-button">
              <img v-else @click="handleChangeShare(item)" src="@/assets/img/share.png" class="home-body-content-img-button">
            </div>
          </div>
          <div v-if="myTabIndex == 2"
            style="position: relative"
            class="home-body-content-item"
            v-for="item in myWorkList"
            :key="item.id"
          >
          <template v-if="item.mediaType == 0">
            <el-image
              @click="handlePlayMyVideo(item)"
              v-if="item.coverUrl"
              style="width: 172px; height: 270px; background-color: #000000"
              :src="item.coverUrl"
              fit="scale-down"
              lazy
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
            <img v-else class="home-body-content-img" src="@/assets/img/defalut.png" />
            <div
             @click="handlePlayMyVideo(item)"
              style="
                position: absolute;
                margin-top: -26px;
                margin-left: -26px;
                top: 50%;
                left: 50%;
              "
            >
              <img style="width: 52px; height: 52px" src="@/assets/img/playerBtn.png" />
            </div>
          </template>
          <template v-if="item.mediaType == 1">
            <el-image
              v-if="item.coverUrl"
              style="width: 172px; height: 270px; background-color: #000000"
              :src="item.coverUrl"
              fit="scale-down"
              :preview-src-list="[item.coverUrl]"
              lazy
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
            <img v-else class="home-body-content-img" src="@/assets/img/defalut.png" />
            <div
              style="
                position: absolute;
                margin-top: -26px;
                margin-left: -26px;
                top: 50%;
                left: 50%;
              "
            >
            </div>
          </template>
            
          </div>
          <div
            class="home-body-content-item"
            style="height: 0; overflow: hidden; opacity: 0"
            v-for="i in 8"
            :key="i + '-#'"
          >
            <img class="home-body-content-img" />
          </div>
          <div v-if="myVideoList.length == 0" class="home-body-content-null">
            <img v-if="myTabIndex == 0" src="@/assets/img/kongwei.png" class="home-body-content-null-img" />
            <img v-if="myTabIndex == 1" src="@/assets/img/photonull.png" class="home-body-content-null-img" />
          </div>
          <div v-if="myWorkList.length == 0 && myTabIndex == 2" class="home-body-content-null">
            <img src="@/assets/img/worknull.png" class="home-body-content-null-img" />
          </div>
        </div>
      </div>
    </div>
    <div v-if="!isMyWork" style="display: flex; justify-content: center; margin-top: 30px">
      <el-pagination
        v-if="total != 0"
        background
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="size"
        layout="prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>
    <div v-if="isMyWork" style="display: flex; justify-content: center; margin-top: 30px">
      <el-pagination
        v-if="mytotal != 0"
        background
        @current-change="handleMyCurrentChange"
        :current-page="mycurrentPage"
        :page-size="mysize"
        layout="prev, pager, next"
        :total="mytotal"
      >
      </el-pagination>
    </div>
    <div class="homepage-footer">
      <div class="homepage-footer-text1">
        Experience advanced AI technology for face swapping.Ideal for
      </div>
      <div class="homepage-footer-text1">
        creative funny photo&videos with high-quality results.
      </div>
      <div class="homepage-footer-text2">
        ©2024 OpenAI Tech. All rights reserved.
      </div>
    </div>
    
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible" width="80%">
      <div style="display: flex; justify-content: center">
        <video :src="videoUrl" height="500" controls autoplay controlslist="nodownload">
          Your browser does not support the video element.
        </video>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Close</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisibleMyVideo" width="80%">
      <div style="display: flex; justify-content: center">
        <video :src="myVideoUrl" height="500" controls autoplay controlslist="nodownload">
          Your browser does not support the video element.
        </video>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleMyVideo = false">Close</el-button>
      </span>
    </el-dialog>
    <el-dialog custom-class="vip-dialog" :close-on-click-modal="false" :visible.sync="VipDialogVisible" width="500px">
      <vipRecharge @paySuccess="paySuccessVip"></vipRecharge>
    </el-dialog>
    <el-dialog custom-class="vip-dialog" :close-on-click-modal="false" :visible.sync="shareDialogVisible" width="500px">
      <Share @declineClick="declineClick" @allowClick="allowClick"></Share>
    </el-dialog>
  </div>
</template>
<script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-3429364286188447"
     crossorigin="anonymous"></script>
<script>
import Vue from 'vue'
import { getUserInfo } from "@/request/modules/login";
import { getMyVideo,shareFile,GetlistMemberVideo,GetTypeList,addHead,submit, GetVideoList,getVideoStatus,getVideoUrlV1,getDownVideoV1  } from "@/request/modules/home.js";
import Share from '../../components/share.vue';
export default {
  name: "MyAppHome",
  components: {Share},
  data() {
    return {
      shareId:0,
      shareDialogVisible:false,
      myVideoUrl:"",
      dialogVisibleMyVideo: false,
      myWorkList:[],
      fullLoading:null,
      myVideoList:[],
      isMyWork: false,
      myTabIndex:0,
      isVideoShare: false,
      isPhotoShare: false,
      isTemplates: 1,
      userInfo:{isVip:false},
      isImgNeedVip:false,
      isVideoNeedVip:false,
      VipDialogVisible:false,
      isShowSwap:false,
      isShowVideoSwap:false,
      headLoading:false,
      isDown:false,
      isVideoDown:false,
      isStart:false,
      isVideoStart:false,
      isClick:false,
      isVideoClick:false,
      jobId:'',
      videojobId:'',
      timeSecond:60,
      videotimeSecond:60,
      waitSum:1,
      videowaitSum:1,
      intervalIdApi:null,
      intervalId: null,
      isCounting: false,
      percentage: 0,
      videointervalIdApi:null,
      videointervalId: null,
      videoisCounting: false,
      videopercentage: 0,
      videoUrlNew: "",
      topTemplatevideoList:[],
      topTemplatePhotoList:[],
      photoHeadList:[],
      videoHeadList:[],
      videoHeadList:[],
      UploadImg:{},
      UploadVideo:{},
      isLogin: false,
      loading:false,
      videoloading:false,
      videoUrl:"",
      dialogVisible: false,
      industryTabIndex: 0,
      typeList: [],
      videoList: [],
      currentPage: 1,
      size: 16,
      total: 0,
      mycurrentPage: 1,
      mysize: 15,
      mytotal: 0,
      isPhoto:2,
      topCurrentPage:1,
      topPhotoUrl:'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
      topPhotosrcList: [
        'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg'
      ],
      upload: {
        isUploading: false, // 是否禁用上传
        url: process.env.VUE_APP_BASE_API_UPLOAD + "/api/app/material/info/uploadImage", // 请求地址
        headUrl: process.env.VUE_APP_BASE_API_UPLOAD + "/api/app/material/info/uploadHead",
        headers: { Authorization: "Bearer " + localStorage.getItem("token") }, // 设置上传的请求头部
        data: {name: 'file',} // 上传的额外数据，用于文件名
      },
      uploadVideoConfig: {
        isUploading: false, // 是否禁用上传
        url: process.env.VUE_APP_BASE_API_UPLOAD + "/api/app/material/info/uploadVideo", // 请求地址
        headers: { Authorization: "Bearer " + localStorage.getItem("token") }, // 设置上传的请求头部
        data: {name: 'file',} // 上传的额外数据，用于文件名
      },
    };
  },
  mixins: [],
  mounted() {
    (window.adsbygoogle = window.adsbygoogle || []).push({});
    if (localStorage.getItem('token')) {
        this.isLogin = true;
     }
    this.GetTopTemplatePhotoList();
    this.GetTopTemplateVideoList();
    this.GetTypeList();
    this.GetVideoList(this.industryTabIndex);
    
    if (localStorage.getItem("userInfo")) {
      this.getUserInfo();
      this.GetMyVideoAndPhotoList(this.myTabIndex);
    }
  },
  methods: {
    handlePlayMyVideo(item){
      this.myVideoUrl = item.saveUrl;
      this.dialogVisibleMyVideo = true;
      this.logEvent('fw_home_Mywork_Video_View',{fw_module_name:'home',fw_page:'home',fw_video_id:item.id})
    },
    async getUserInfo() {
      var res = await getUserInfo();
      localStorage.setItem("userInfo", JSON.stringify(res));
      this.userInfo = res ;
    },
    loginClick(){
      this.$router.push({ path: `/login` });
    },
    async OpenVideoUrlPlay() {
      // this.videoUrl = this.videoUrlOld;
      this.dialogVisible = true;
    },
    uphead() {
      // 选择图片
    },
    load(){},
    beforeAvatarUpload(file) {
        const isJPG = (file.type === 'image/jpeg' || file.type === 'image/png');
        const isLt2M = file.size / 1024 / 1024 < 10;

        if (!isJPG) {
          this.$message.error('Please upload images in PNG or JPG format!');
        }
        if (!isLt2M) {
          this.$message.error('The size of the uploaded image cannot exceed 10MB!');
        }
        if (isJPG && isLt2M) {
          this.loading = true;
        }
        return isJPG && isLt2M;
    },
    beforeMyAvatarUpload(file) {
        const isJPG = (file.type === 'image/jpeg' || file.type === 'image/png');
        const isLt2M = file.size / 1024 / 1024 < 10;

        if (!isJPG) {
          this.$message.error('Please upload images in PNG or JPG format!');
        }
        if (!isLt2M) {
          this.$message.error('The size of the uploaded image cannot exceed 10MB!');
        }
        return isJPG && isLt2M;
    },
    beforeAvatarUploadHead(file) {
        const isJPG = (file.type === 'image/jpeg' || file.type === 'image/png');
        const isLt2M = file.size / 1024 / 1024 < 10;

        if (!isJPG) {
          this.$message.error('Please upload images in PNG or JPG format!');
        }
        if (!isLt2M) {
          this.$message.error('The size of the uploaded avatar image cannot exceed 10MB!');
        }
        if (isJPG && isLt2M) {
          this.headLoading = true;
        }
        return isJPG && isLt2M;
    },
    beforeVideoHeadUpload(file) {
        const isJPG = (file.type === 'image/jpeg' || file.type === 'image/png');
        const isLt2M = file.size / 1024 / 1024 < 10;

        if (!isJPG) {
          this.$message.error('Please upload images in PNG or JPG format!');
        }
        if (!isLt2M) {
          this.$message.error('The size of the uploaded avatar image cannot exceed 10MB!');
        }
        if (isJPG && isLt2M) {
          this.headLoading = true;
        }
        return isJPG && isLt2M;
    },
    beforeVideoUpload(file) {
      this.videoloading = true;
        const isJPG = (file.type === 'video/mp4');
        const isLt2M = file.size / 1024 / 1024 < 100;

        if (!isJPG) {
          this.$message.error('Please upload video in MP4 format!');
        }
        if (!isLt2M) {
          this.$message.error('The size of the uploaded video cannot exceed 100MB!');
        }
        return isJPG && isLt2M;
    },
    beforeMyVideoUpload(file) {
        const isJPG = (file.type === 'video/mp4');
        const isLt2M = file.size / 1024 / 1024 < 100;

        if (!isJPG) {
          this.$message.error('Please upload video in MP4 format!');
        }
        if (!isLt2M) {
          this.$message.error('The size of the uploaded video cannot exceed 100MB!');
        }
        return isJPG && isLt2M;
    },
    async handleAvatarSuccess(res, file) {
        console.log("res", res);
        console.log("file", file.response.data);
        this.loading = false;
        this.isDown = false;
        this.isShowSwap = false;
        if (file.response.data) {
          this.UploadImg = file.response.data;
          this.topPhotosrcList = [this.UploadImg.coverUrl];
          this.photoHeadList = JSON.parse(this.UploadImg.headImg);
          this.isImgNeedVip = true;
          this.isPhotoShare = false;
          this.openConfirm(1,file.response.data.id);
        }else{
          this.$message({
            message: file.response.msg,
            type: "error",
          });
        }
        this.logEvent('fw_home_photo_upload',{fw_module_name:'home',fw_page:'home'})
    },
    handleMyAvatarSuccess(res, file) {
        this.fullLoading.close();
        console.log("file", file);
        if (file.response.data) {
          // this.UploadVideo = file.response.data;
          this.openConfirm(1,file.response.data.id);
          this.mycurrentPage = 1;
          this.GetMyVideoAndPhotoList(this.myTabIndex);
        }else{
          this.$message({
            message: file.response.msg,
            type: "error",
          });
        }
        this.logEvent('fw_home_myPhotos_upload',{fw_module_name:'home',fw_page:'home'})
    },
    handleFileProgress(){
      this.fullLoading = this.$loading({
          lock: true,
          text: 'loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
    },
    openConfirm(type,id) {
      this.shareId = id;
      this.shareDialogVisible = true;
      // const h = this.$createElement;
      //   this.$msgbox({
      //     title: '',
      //     message: h('p', null, [
      //       h('span',  { style: 'font-family: PingFang SC;' }, type == 1 ? 'Allow my photo to inspire the community by being used as a template.' : 'Allow my video to inspire the community by being used as a template.'),
      //     ]),
      //     showCancelButton: true,
      //     confirmButtonText: 'Yes',
      //     cancelButtonText: 'No',
      //     beforeClose: (action, instance, done) => {
      //       if (action === 'confirm') {
      //         shareFile(id);
      //         done();
      //       } else {
      //         done();
      //       }
      //     }
      //   }).then(action => {
      //   });
    },
    declineClick(){
      this.shareDialogVisible = false;
    },
    allowClick(){
      shareFile(this.shareId);
      this.shareDialogVisible = false;
    },
    async handleVideoSuccess(res, file) {
        console.log("res", res);
        console.log("file", file.response.data);
        this.videoloading = false;
        this.isVideoDown = false;
        this.isShowVideoSwap = false;
        if (file.response.data) {
          this.UploadVideo = file.response.data;
          this.videoUrl = this.UploadVideo.videoUrl;
          this.videoHeadList = JSON.parse(this.UploadVideo.headImg);
          this.isVideoNeedVip = true;
          this.isVideoShare = false;
          this.openConfirm(0,file.response.data.id);
        }else{
          this.$message({
            message: file.response.msg,
            type: "error",
          });
        }
        this.logEvent('fw_home_video_upload',{fw_module_name:'home',fw_page:'home'})
    },
    async handleMyVideoSuccess(res, file) {
        this.fullLoading.close();
        if (file.response.data) {
          // this.UploadVideo = file.response.data;
          this.openConfirm(0,file.response.data.id);
          this.mycurrentPage = 1;
          this.GetMyVideoAndPhotoList(this.myTabIndex);
        }
        this.logEvent('fw_home_myVideos_upload',{fw_module_name:'home',fw_page:'home'})
    },
    handleCurrentChange(val) {
      if (typeof val == "number") {
        this.currentPage = val;
      }
      this.GetVideoList(this.industryTabIndex);
    },
    handleMyCurrentChange(val) {
      if (typeof val == "number") {
        this.mycurrentPage = val;
      }
      this.GetMyVideoAndPhotoList(this.myTabIndex);
    },
    async GetTypeList() {
      var res = await GetTypeList({
        typeId: 7007,
        p: 1,
        s: 100,
        o: 1,
        c: "sort",
      });
      this.typeList = res.rows;
      this.typeList = this.typeList.filter(item => item.value !== '9');
      console.log("typeList", this.typeList);
    },
    MenuClick(index) {
      if (index == this.isPhoto) {
        return;
      }
      this.isPhoto = index;
      this.topCurrentPage = 1;
      this.logEvent('fw_home_top_menu',{fw_module_name:'home',fw_page:'home',fw_event_id:index})
      //this.GetVideoList(index);
    },
    ChangeIsTemplatesTag(index) {
      if (index == this.isTemplates) {
        return;
      }
      this.isTemplates = index;
      if (index == 1) {
        this.isMyWork = false;
      }else{
        this.isMyWork = true;
      }
      this.logEvent('fw_home_menu',{fw_module_name:'home',fw_page:'home',fw_event_id:index})
      //this.currentPage = 1;
    },
    ChangeMyTag(index) {
      if (index == this.myTabIndex) {
        return;
      }
      this.myTabIndex = index;
      this.mycurrentPage = 1;
      this.GetMyVideoAndPhotoList(index);
      this.logEvent('fw_home_my_menu',{fw_module_name:'home',fw_page:'home',fw_event_id:index})
    },
    ChangeTag(index) {
      if (index == this.industryTabIndex) {
        return;
      }
      this.industryTabIndex = index;
      this.currentPage = 1;
      this.GetVideoList(index);
      this.logEvent('fw_home_template_menu_click',{fw_module_name:'home',fw_page:'home',fw_event_id:index})
    },
    async GetMyVideoAndPhotoList(currentType){
      var params = {p: this.mycurrentPage,s: this.mysize};
      switch (currentType) {
        case 0:
          Vue.set(params, "mediaType", 0);
          break;
        case 1:
          Vue.set(params, "mediaType", 1);
          break;
        case 2:
          Vue.set(params, "videoStatus", 2);
          break;  
        default:
          break;
      }
      if (currentType == 2) {
        params.s = params.s + 1;
        var res = await getMyVideo(params);
        console.log("res", res);
        this.myWorkList = res.rows;
        this.mytotal = res.total;
      }else{
        var res = await GetlistMemberVideo(params);
        this.myVideoList = res.rows;
        this.mytotal = res.total;
      }
    },
    async GetVideoList(currentType) {
      var params = {p: this.currentPage,s: this.size};
      switch (currentType) {
        case 0:
          Vue.set(params, "isNew", true);
          break;
        case -1:
          Vue.set(params, "isHot", true);
          Vue.set(params, "mediaType", 0);
          break;
        case -2:
          Vue.set(params, "mediaType", 1);
          break;
        case -3:
          Vue.set(params, "isShare", true);
          Vue.set(params, "mediaType", 0);
          break;
        case -4:
          Vue.set(params, "isShare", true);
          Vue.set(params, "mediaType", 1);
          break;
        default:
           Vue.set(params, "type", currentType);
          break;
      }
      var res = await GetVideoList(params);
      let newRows = res.rows.map(item => ({
        ...item, 
        isPhotoOk: false
      }));
      this.videoList = newRows;
      console.log("sasdadas",this.videoList)
      if (currentType != 0) {
        this.total = res.total;
      }
    },
    GetTopTemplateVideoList() {
      GetVideoList({
          isHot: true,
          p: 1,
          s: 10,
          mediaType:0,
        }).then(res => {
          this.topTemplatevideoList = res.rows;
          this.UploadVideo = this.topTemplatevideoList[0];
          this.videoUrl = this.UploadVideo.videoUrl;
          this.videoHeadList = JSON.parse(this.UploadVideo.headImg);
        });
    },
    GetTopTemplatePhotoList() {
      GetVideoList({
          isHot: true,
          p: 1,
          s: 10,
          mediaType:1,
        }).then(res => {
          this.topTemplatePhotoList = res.rows;
          this.UploadImg = this.topTemplatePhotoList[0];
          this.topPhotosrcList = [this.UploadImg.coverUrl];
          this.photoHeadList = JSON.parse(this.UploadImg.headImg);
        });
    },
    ChangePhotoTeplate(item){
      if (this.isClick) {
        this.$message({
          message: 'face swapping, please wait！',
          type: 'warning'
        });
        return;
      }
      this.UploadImg = item;
      this.topPhotosrcList = [this.UploadImg.coverUrl];
      this.photoHeadList = JSON.parse(this.UploadImg.headImg);
      this.isDown = false;
      this.isShowSwap = false;
      this.isImgNeedVip = false;
      this.logEvent('fw_home_photo_template',{fw_module_name:'home',fw_page:'home'})
    },
    ChangeVideoTeplate(item){
      if (this.isVideoClick) {
        this.$message({
          message: 'face swapping, please wait！',
          type: 'warning'
        });
        return;
      }
      this.UploadVideo = item;
      this.videoUrl = this.UploadVideo.videoUrl;
      this.videoHeadList = JSON.parse(this.UploadVideo.headImg);
      this.isVideoDown = false;
      this.isShowVideoSwap = false;
      this.isVideoNeedVip = false;
      this.logEvent('fw_home_video_template',{fw_module_name:'home',fw_page:'home'})
    },
    handleGoFace(item) {
      console.log("item", item);
      if (item.isVip && !this.userInfo.isVip) {
        this.showPaymentDialog();
        return;
      }
      var query = {
        id: item.id,
        videoUrl: item.videoUrl,
        headImg: item.headImg,
        isVip: item.isVip,
        videoImg: item.coverUrl,
        upType: item.upType,
        mediaType: item.mediaType,  
      };
      this.$router.push({ path: `/face/templateView`, query: query });
      this.logEvent('fw_home_template_click',{fw_module_name:'home',fw_page:'home',fw_video_id:item.id})
    },
    async handleAvatarSuccessByPhotoHead(response, file, fileList, index) {
        console.log("file", file.response.data);
        console.log("index", index);
        this.isDown = false;
        if (file.response.data) {
          var res = await addHead({
          headUrl: file.response.data
          });
          this.photoHeadList[index].choseId = res.id;
          this.photoHeadList[index].choseImgUrl = res.headUrl;
        }else{
          this.$message({
            message: file.response.msg,
            type: "error",
          });
        }
        this.headLoading = false;
        this.isShowSwap = true;
        this.logEvent('fw_home_photo_upload_face',{fw_module_name:'home',fw_page:'home'})
    },
    async handleAvatarSuccessByVideoHead(response, file, fileList, index) {
        console.log("file", file.response.data);
        console.log("index", index);
        this.isVideoDown = false;
        if (file.response.data) {
          var res = await addHead({
          headUrl: file.response.data
          });
          this.videoHeadList[index].choseId = res.id;
          this.videoHeadList[index].choseImgUrl = res.headUrl;
        }else{
          this.$message({
            message: file.response.msg,
            type: "error",
          });
        }
        this.headLoading = false;
        this.isShowVideoSwap = true;
        this.logEvent('fw_home_video_upload_face',{fw_module_name:'home',fw_page:'home'})
    },
    async startSwap(){
      if(this.photoHeadList.every(photoHeadList => photoHeadList.choseImgUrl == '')){
            return
        }
        if (this.isImgNeedVip && !this.userInfo.isVip) {
          this.VipDialogVisible = true;
          this.logEvent('fw_home_vip_continue',{fw_module_name:'home',fw_page:'home'})
          return;
        }
        this.isClick = true;
        this.loading = true;
        this.isDown = false;
        //this.videoUrlNew = '';
        var res = await submit({
            sourceVideoId:this.UploadImg.id,
            faceHeadMapping:this.photoHeadList
        });
        this.jobId = res.jobId;
        this.timeSecond = res.timeSecond;
        this.waitSum = res.waitSum;
        console.log('huanlian',res)
        this.isStart = true;
        this.startCounting();
        this.logEvent('fw_home_photo_swap',{fw_module_name:'home',fw_page:'home'})
    },
    async startVideoSwap(){
      if(this.videoHeadList.every(videoHeadList => videoHeadList.choseImgUrl == '')){
            return
        }
        if (this.isVideoNeedVip && !this.userInfo.isVip) {
          this.VipDialogVisible = true;
          this.logEvent('fw_home_vip_continue',{fw_module_name:'home',fw_page:'home'})
          return;
        }
        this.isVideoDown = false;
        this.isVideoClick = true;
        this.videoloading = true;
        //this.videoUrlNew = '';
        var res = await submit({
            sourceVideoId:this.UploadVideo.id,
            faceHeadMapping:this.videoHeadList
        });
        this.videojobId = res.jobId;
        this.videotimeSecond = res.timeSecond;
        this.videowaitSum = res.waitSum;
        console.log('huanshiping',res)
        this.isVideoStart = true;
        this.startVideoCounting();
        this.logEvent('fw_home_video_swap',{fw_module_name:'home',fw_page:'home'})
    },
    startCounting() {
      if (this.intervalId) return; // 如果已经在计数，防止重复启动
      this.checkImgStatus();
      this.isCounting = true;
      this.intervalId = setInterval(() => {
        if (this.percentage < 99) {
          this.percentage = this.percentage + Math.floor(100 / this.timeSecond);
        } else {
          this.stopCounting(); // 达到100后自动停止
        }
      }, 1000);
    },
    startVideoCounting() {
      if (this.videointervalId) return; // 如果已经在计数，防止重复启动
      this.checkVideoStatus();
      this.videoisCounting = true;
      this.videointervalId = setInterval(() => {
        if (this.videopercentage < 99) {
          this.videopercentage = this.videopercentage + Math.floor(100 / this.videotimeSecond);
        } else {
          this.stopCounting(); // 达到100后自动停止
        }
      }, 1000);
    },
    checkImgStatus() {
        if (this.intervalIdApi) return;
        this.intervalIdApi = setInterval(async () => {
            var res = await getVideoStatus({
                jobId: this.jobId
            });
            if (res == 2) {
                this.clearInterval(); // 停止定时器
                this.stopCounting();
                this.fetchImgUrl(); // 获取视频URL
            } else if (res == 4) {
                this.clearInterval(); // 停止定时器
            }
        }, 3000); // 每2秒调用一次
    },
    checkVideoStatus() {
        if (this.videointervalIdApi) return;
        this.videointervalIdApi = setInterval(async () => {
            var res = await getVideoStatus({
                jobId: this.videojobId
            });
            if (res == 2) {
                this.clearVideoInterval(); // 停止定时器
                this.stopVideoCounting();
                this.fetchVideoUrl(); // 获取视频URL
            } else if (res == 4) {
                this.clearVideoInterval(); // 停止定时器
            }
        }, 3000); // 每2秒调用一次
    },
    stopCounting() {
      clearInterval(this.intervalId);
      this.intervalId = null;
      this.isCounting = false;
    },
    clearInterval(){
        clearInterval(this.intervalIdApi);
        this.intervalIdApi = null;
    },
    stopVideoCounting() {
      clearInterval(this.videointervalId);
      this.videointervalId = null;
      this.videoisCounting = false;
    },
    clearVideoInterval(){
        clearInterval(this.videointervalIdApi);
        this.videointervalIdApi = null;
    },
    async fetchImgUrl() {
        var res = await getVideoUrlV1({
            jobId:this.jobId
        });
        this.SaveImg();
    },
    async fetchVideoUrl() {
        // var res = await getVideoUrlV1({
        //     jobId:this.videojobId
        // });
        this.SaveVideo();
    },
    SaveVideo(){
      getDownVideoV1({
        jobId:this.videojobId
        }).then(res => {
          //这里写展现视频的逻辑
          this.UploadVideo.coverUrl = res.coverUrl ? res.coverUrl : this.UploadVideo.coverUrl;
          this.videoUrl = res.saveUrl;
          this.isVideoStart = false;
          this.isVideoClick = false;
          this.videoloading = false;
          this.isVideoDown = true;
        });
    },
    SaveImg(){
      getDownVideoV1({
        jobId:this.jobId
        }).then(res => {
          //这里写展现视频的逻辑
          this.UploadImg.coverUrl = res.saveUrl ? res.saveUrl : this.UploadImg.coverUrl;
          this.topPhotosrcList = [res.saveUrl];
          this.isStart = false;
          this.isClick = false;
          this.loading = false;
          this.isDown = true;
        });
    },
    DownImg(){
      const loading = this.$loading({
          lock: true,
          text: 'loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
          loading.close();
        }, 2000);
        this.downloadFile(this.UploadImg.coverUrl,'FaceWave'+Math.floor(10000 + Math.random() * 90000)+'.png')
        this.logEvent('fw_home_photo_down',{fw_module_name:'home',fw_page:'home'})
    },
    DownVideo(){
      const loading = this.$loading({
          lock: true,
          text: 'loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
          loading.close();
        }, 2000);
        this.downloadFile(this.videoUrl,'FaceWave'+Math.floor(10000 + Math.random() * 90000)+'.mp4')
        this.logEvent('fw_home_video_down',{fw_module_name:'home',fw_page:'home'})
    },
    downloadFile(url, name) {
      const xhr = new XMLHttpRequest();
      // 使用open()方法初始化一个请求，第一个参数为请求的类型，第二个参数为请求的地址，第三个参数为是否异步
      xhr.open('GET', url, true);
      // 设置响应的数据类型
      xhr.responseType = 'blob';
      // 当请求加载完成时，触发onload事件
      xhr.onload = () => {
        // 如果请求的状态码为200，表示请求成功
        if (xhr.status === 200) {
          // 创建一个blob对象，第一个参数为响应的数据，第二个参数为blob对象的类型
          const blob = new Blob([xhr.response], { type: xhr.getResponseHeader('content-type') });
          // 创建一个a标签
          const link = document.createElement('a');
          // 为a标签设置href属性，值为blob对象的URL
          link.href = URL.createObjectURL(blob);
          // 为a标签设置下载文件名
          link.download = name;
          // 点击a标签，开始下载文件
          link.click();
        }
      };
      // 发送请求
      xhr.send();
    },
    paySuccessVip(){
      this.getUserInfo();
      this.VipDialogVisible = false;
    },
    showPaymentDialog(){
      if (!this.isLogin) {
        this.loginClick();
        return;
      }
      this.VipDialogVisible = true;
      this.logEvent('fw_home_vip_continue',{fw_module_name:'home',fw_page:'home'})
    },
    handleChangeShare(item){
      shareFile(item.id);
      item.isShare = !item.isShare;
    },
    imgLoadOk(item){
      console.log('item',item)
      item.isPhotoOk = true;
    }
  },
};
</script>

<style lang="less" scoped>
.home-page {
  color: #ffffff;
}
.title-font {
  margin-top: 20px;
  color: #ffffff;
  font-family: PingFang SC;
  font-size: 60px;
  font-weight: 600;
  line-height: normal;
  text-align: center;
  letter-spacing: 0em;
  .title-font-two {
    background: -webkit-linear-gradient(left, #e7166b, #821ced);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    display: inline-block;
  }
}
.home-top{
  display: flex;
  justify-content: center;
  .home-top-menu{
    margin-top: 20px;
    width: 520px;
    height: 50px;
    display: flex;
    justify-content: space-between;
    .home-top-menu-photo{
      width: 250px;
      height: 50px;
      background: #111111;
      border: 1px solid #475569;
      border-radius: 45px;
      text-align: center;
      line-height: 50px;
      font-family: PingFang SC;
      font-size: 24px;
      cursor: pointer;
    }
    .home-top-menu-photo:hover {
      background: #475569;
    }
    .home-top-menu-photo.active {
      background: #475569;
    }
  }
}
.home-top-content{
  margin-top: 20px;
  display: flex;
  justify-content: center;
  .home-top-content-photo{
    width: 1110px;
    height: 679px;
    border-radius: 30px;
    background: #FFFFFF;
    border: 1px solid #FFFFFF;
    display: flex;
  }
  .home-top-content-img{
    margin-top: 20px;
    margin-left: 66px;
    width: 128px;
    .home-top-content-img-upload{
      height: 128px;
      width: 128px;
      margin-bottom: 10px; 
    }
    .home-top-content-img-upload-content{
      cursor: pointer;
      margin-top: 20px;
      .home-top-content-img-upload-icon{
        height: 128px;
        width: 128px;
        border-radius: 15px;
      }
    }
  }
  .home-top-content-photo-main{
    margin: 20px 0 20px 50px;
    width: 360px; 
    height: 640px;
    background: #111111;
    .templateview-content-video-content-img {
      width: 360px;
      height: 640px;
    }
    ::v-deep .el-loading-mask{
      opacity: 0.5;
    }
    font-size: 60px;
    ::v-deep .el-loading-spinner .el-loading-text{
      color: #FFFFFF;
      font-family: PingFang SC;
      font-size: 24px;
    }
  }
  .home-top-content-photo-face{
    align-items: center;
    color: #3D3D3D;
    height: 660px;
    flex:1;
    display: flex;
    .home-top-content-photo-face-text{
      font-family: PingFang SC;
      font-size: 24px;
      text-align: center;
    }
    .home-top-content-photo-swapping{
      margin-top: 20px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .home-top-content-photo-swapping-head{
        height: 128px;
        width: 128px;
        border-radius: 50%;
      }
      .home-top-content-photo-swapping-change{
        height: 40px;
        width: 40px;
      }
      .home-top-content-photo-headimg-box-l {
        line-height: 0;
        position: relative;
      }
      .home-top-content-photo-headimg-box-l-upload{
        width: 128px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .home-top-content-photo-headimg-box-l-img-box {
        border: 1px dashed #767676;
        overflow: hidden;
        border-radius: 50%;
        height: 128px;
        width: 128px;
        display: flex;
        justify-content: center;
        align-items: center;
        .home-top-content-photo-headimg-box-l-img-box-shizicha{
          width: 40px;
          height: 40px;
        }
        .home-top-content-photo-headimg-box-l-img-box-text{
          width: 90px;
          height: 14px;
        }
      }
      .home-top-content-photo-headimg-box-l-img {
        height: 128px;
        width: 128px;
        border-radius: 50%;
      }
      .home-top-content-photo-headimg-box-l-img-edit-icon{
        position: absolute;
        width: 30px;
        height: 30px;
        bottom: 0;
        right: 0;
      }
    }
    .home-top-content-photo-start{
      display: flex;
      justify-content: center;
      margin-top: 40px;
    }
    .home-top-content-photo-down{
      display: flex;
      justify-content: center;
      margin-top: 10px;
    }
  }
}
.home-body {
  padding: 30px 5% 0 5%;
  .home-body-title {
    font-family: PingFang SC;
    font-size: 20px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    .home-body-title-text{
      width: 250px;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #475569;
      cursor: pointer;
    }
    .home-body-title-text.active {
      background: #475569;
    }
  }
  .home-body-content-menu {
    display: flex;
    margin-top: 30px;
    .underline{
			  position: absolute;
			  width: 80%;
        bottom: 1px;
			  height: 1px; /* 下划线的高度 */
			  background: linear-gradient(90deg, #8C1AF0 0%, #00FFFF44 60%, #00FFFF00 100%);
			  transform: translateX(-50%);
			  left: 50%; /* 将下划线左边缘置于父元素中心 */
			  width: 80%; /* 设置下划线宽度为80% */
			  transition: transform 0.3s linear;
			}
    .home-body-content-menu-style {
      // background: rgba(255, 255, 255, 0.1);
      // border-radius: 4px;
      position: relative;
      height: 34px;
      align-items: center;
      display: flex;
      justify-content: center;
      margin-right: 20px;
      color: #aaaaaa;
      font-family: PingFang SC;
      font-size: 14px;
      font-weight: 600;
      line-height: 22px;
      cursor: pointer;
      padding: 0 12px; 
      white-space: nowrap;
    }
    .home-body-content-menu-style:hover {
      // background: rgba(255, 255, 255, 0.6);
      // color: #111111;
    }
    .home-body-content-menu-style.active {
      // background: rgba(255, 255, 255, 0.6);
      // color: #111111;
      color: #FFFFFF;
      font-size: 16px;
      font-family: PingFang SC;
      font-style: italic;
      
    }
    .topRec-img {
      width: 16px;
      height: 16px;
      margin-right: 2px;
    }
  }
  .home-body-content {
    // min-height: 610px;
    position: relative;
    margin-top: 30px;
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    .home-body-content-img {
      height: 270px;
      width: 172px;
      cursor: pointer;
    }
    .home-body-content-img-share-overlay-buttons{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      opacity: 0;
      transition: opacity 0.3s ease-in-out;
      pointer-events: none;
      text-align: center;
    }
    .home-body-content-item:hover .home-body-content-img-share-overlay-buttons {
      opacity: 1;
      pointer-events: auto;
    }
    .home-body-content-img-button{
      height: 40px;
      width: 120px;
      cursor: pointer;
      display: block;
      margin: 10px 0;
      position: static;
    }
    .wrapper{
      position: relative;
      height: fit-content;
    }
    .home-body-content-item {
      padding: 12px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .home-body-content-null{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      .home-body-content-null-img{
        width: 344px;
        height: 177px;
      }
    }
  }
  ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #ec2842;
    color: #fff;
  }
}
.coming-soon{
  height: 300px;
  text-align: center;
  font-family: PingFang SC;
  font-size: 40px;
  margin-top: 150px
}
/* 修改前后箭头未点击时的背景颜色 */
:deep .el-pagination .btn-prev,
:deep .el-pagination .btn-next {
  background-color: #262727 !important;
}
/* 修改未点击时的数字方块背景颜色 */
:deep .el-pagination .el-pager li:not(.active):not(.disabled):hover {
  background-color: #409EFF !important;
}
/* 未点击时的数字方块背景颜色 */
:deep .el-pagination .el-pager li:not(.active):not(.disabled) {
  background-color: #262727 !important;
  color: #000000;
}
:deep(.el-pagination.is-background .el-pager li:not(.is-disabled).is-active) {
  background-color: #409EFF !important; //修改默认的背景色
  color: #000000;
}
::-webkit-scrollbar {
    display: none;
}
:deep .image-slot{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
}
.homepage-footer{
  margin-top: 40px;
  .homepage-footer-text1{
    font-family: PingFang SC;
    font-size: 16px;
    line-height: normal;
    text-align: center;
    color: #767676;
  }
  .homepage-footer-text2{
    margin-top: 10px;
    font-family: PingFang SC;
    font-size: 16px;
    line-height: normal;
    text-align: center;
    color: #FFFFFF;
  }
}
:deep .vip-dialog{
  border-radius: 30px;
  // background-color: #000000;
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6); /* 蒙层颜色和透明度 */
  display: flex;
  justify-content: center;
  align-items: center;
  .lock-icon {
    width: 88px; 
    height: 100px;
    margin-bottom: 40px;
  }
  .lock-text{
    font-family: PingFang SC;
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
    text-align: center;
    color: #FFFFFF;
    letter-spacing: 0px;
  }
  .lock-icon-unlock {
    width: 343px; 
    height: 50px;
    margin-top: 40px;
    cursor: pointer;
  }
}
</style>
